module Meevo.Plugins.SystemToolbox {

    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<null>{

        private securityKeys = Meevo.Components.Common.SecurityKeys;
        public resetClientPointsSecurityKey: string;
        public isClientPointResetInProgress: boolean = true;
        public showClientPointResetSubSection: boolean;

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            public securityService: Meevo.Components.Common.ISecurityService,
            noun: Meevo.Model.NounEnum,
            appSettings: Components.Common.IAppSettings,
            protected modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey: string,
            private context: SystemToolboxContext,
            public $rootScope: angular.IRootScopeService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            public $translate: ng.translate.ITranslateService) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey, $translate);
            this.noun = Model.NounEnum.SystemToolboxMain;

            this.getClientPointResetStatus();
            this.setupSecurityKeys();
        }

        setupSecurityKeys() {
            this.resetClientPointsSecurityKey = this.securityKeys.BUSINESSINFO_SYSTEMTOOLBOX_FIELD_RESETCLIENTPOINTS;
            this.showClientPointResetSubSection = this.securityService.hasSecurityDenyOrGrant(this.resetClientPointsSecurityKey + 
                Meevo.Components.Common.SecurityParts.KEY_PART_READ);
        }

        getClientPointResetStatus() {
            var url = `${this.baseEndpoint}/ClientPointsReset`;
            this.dataService.customMethodData(url, 'GET', { }).then(res => {
                this.isClientPointResetInProgress = res && res.data;
            });
        }

        resetClientPoints() {

            if (this.isClientPointResetInProgress) {
                return;
            }

            const options: Components.Modal.ILocalOptions = {
                okButtonContentKey: 'LABEL_YES',
                showCancelButton: true,
                cancelButtonContentKey: 'LABEL_NO',
                modalClass: 'modal-alert'
            }

            this.modalService
                .confirm('MESSAGE_RESET_CLIENT_POINTS_ALERT', Components.Modal.ModalTranslationModes.Translate, false, options, true)
                .then(res => {
                    if (!res) {
                        this.context.saveTrackingInfo(Model.VerbEnum.ResetClientPointsAlertNoClicked);
                        return;
                    }

                    this.context.saveTrackingInfo(Model.VerbEnum.ResetClientPointsAlertYesClicked);

                    options.modalClass = 'modal-warning';

                    this.modalService
                        .confirm('MESSAGE_RESET_CLIENT_POINTS_WARNING', Components.Modal.ModalTranslationModes.Translate, false, options, true)
                        .then(res => {
                            if (!res) {
                                this.context.saveTrackingInfo(Model.VerbEnum.ResetClientPointsWarningNoClicked);
                                return;
                            }
                            var url = `${this.baseEndpoint}/ClientPointsReset`;
                            this.context.saveTrackingInfo(Model.VerbEnum.ResetClientPointsWarningYesClicked);
                            this.dataService.customMethodData(url, 'POST', { }).then(res => {
                                this.isClientPointResetInProgress = res && res.status === 200;
                            });
                        });
                });
                        
        }
    }

}